import { render } from "./AppSkeletonSearch.vue?vue&type=template&id=6f8aa648&scoped=true"
import script from "./AppSkeletonSearch.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonSearch.vue?vue&type=script&lang=ts"

import "./AppSkeletonSearch.vue?vue&type=style&index=0&id=6f8aa648&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f8aa648"

export default script